module.exports = __webpack_public_path__ + "img/2024122001.e52d94ae.jpg";